import { render, staticRenderFns } from "./Grid.vue?vue&type=template&id=7c0a1dfa&scoped=true&"
import script from "./Grid.vue?vue&type=script&lang=ts&"
export * from "./Grid.vue?vue&type=script&lang=ts&"
import style0 from "./Grid.vue?vue&type=style&index=0&id=7c0a1dfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0a1dfa",
  null
  
)

export default component.exports